import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Injectable} from '@angular/core';
// import {isNumber, toInteger, padNumber} from '@ng-bootstrap/ng-bootstrap/util/util';
import {isNumeric} from 'rxjs/internal-compatibility';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('-');
      if (dateParts.length === 1 && isNumeric(dateParts[0])) {
        return {day: parseInt(dateParts[0]), month: null, year: null};
      } else if (dateParts.length === 2 && isNumeric(dateParts[0]) && isNumeric(dateParts[1])) {
        return {day: parseInt(dateParts[0]), month: parseInt(dateParts[1]), year: null};
      } else if (dateParts.length === 3 && isNumeric(dateParts[0]) && isNumeric(dateParts[1]) && isNumeric(dateParts[2])) {
        return {day: parseInt(dateParts[0]), month: parseInt(dateParts[1]), year: parseInt(dateParts[2])};
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    return date ?
      `${isNumeric(date.day) ? this.pad(date.day) : ''}.${isNumeric(date.month) ? this.pad(date.month) : ''}.${date.year}` :
      '';
  }

  pad(n) {
    return (n < 10) ? ("0" + n) : n;
  }

}
